import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import ActionModal from 'components/Shared/ActionModal/ActionModal';
import SegmentIO from 'reporting/SegmentIO';
import { modalActions } from 'store/modal/slice';
import { cancelSubscriptionPayment } from 'store/payment/slice';
import { colors } from 'styles/cp';

export interface Props {
  hideModal: () => any;
  cancelSubscriptionPayment: () => any;
}

const SubscriptionCancelModal: React.FC<Props> = ({ hideModal, cancelSubscriptionPayment }) => {
  const onCancel = () => {
    SegmentIO.transactionEngaged({
      ui_object: 'button',
      ui_object_detail: 'cancel_subcription',
      ui_action: 'clicked',
      ui_access_point: 'modal',
    });
    cancelSubscriptionPayment();
  };

  const onHide = () => {
    SegmentIO.transactionEngaged({
      ui_object: 'button',
      ui_object_detail: 'hide_modal',
      ui_action: 'clicked',
      ui_access_point: 'modal',
    });
    hideModal();
  };

  return (
    <Fragment>
      <ActionModal
        hide={onHide}
        onContinue={onCancel}
        width="115px"
        headerIntl={{
          id: 'SUBSCRIPTION_MODAL_CANCEL_HEADER',
          defaultMessage: 'Cancel this recurring payment?',
        }}
        continueIntl={{
          id: 'SUBSCRIPTION_MODAL_CANCEL_CONTINUE',
          defaultMessage: 'Yes, cancel',
        }}
        cancelIntl={{
          id: 'SUBSCRIPTION_MODAL_CANCEL_ABORT',
          defaultMessage: 'Don’t cancel',
        }}
        hideOnContinueFinish={false}
      >
        <div className="modal-info-wrapper">
          <FormattedMessage
            id="SUBSCRIPTION_MODAL_CANCEL_INFO"
            defaultMessage="If you cancel, you’ll no longer receive this product or service. Your future recurring payments will also be canceled."
          />
          <div className="second-p">
            <FormattedMessage
              id="SUBSCRIPTION_MODAL_CANCEL_TO_RESUBSCRIBE"
              defaultMessage="To set up recurring payments again, you'll need to contact the company directly."
            />
          </div>
        </div>
      </ActionModal>
      <style jsx>{`
        .modal-info-wrapper {
          color: ${colors.gray};
          .second-p {
            margin-top: 24px;
          }
        }
      `}</style>
    </Fragment>
  );
};

export { SubscriptionCancelModal };

export default connect(() => ({}), {
  hideModal: modalActions.hide,
  cancelSubscriptionPayment,
})(SubscriptionCancelModal as any);
